import { render, staticRenderFns } from "./CreateOpenShiftResponse.vue?vue&type=template&id=51968712&"
import script from "./CreateOpenShiftResponse.vue?vue&type=script&lang=ts&"
export * from "./CreateOpenShiftResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports